import CampaignJobBoardForm from "./CampaignJobBoardForm";

import { useCampaignJobBoards } from "@/features/campaigns/jobboards/api/useCampaignJobBoards";
import { AddCampaignJobBoardRequest } from "@/types/request/AddCampaignJobBoardRequest";

type AddCampaignJobBoardFormProps = {
  campaignId: string;
  clientId?: string;
  errorMessage?: string | null;
  isSubmitting?: boolean;
  onSubmitForm?: (data: AddCampaignJobBoardRequest) => void;
  onSuccess?: () => void;
};

function AddCampaignJobBoardForm({
  campaignId,
  clientId,
  errorMessage,
  isSubmitting,
  onSubmitForm,
  onSuccess,
}: AddCampaignJobBoardFormProps) {
  const { data: campaignJobBoards, isLoading, isFetching } = useCampaignJobBoards({
    campaignId,
    clientId,
  });

  const handleSubmit = (payload: AddCampaignJobBoardRequest) => {
    if (onSubmitForm) {
      onSubmitForm(payload);
    }
  };

  return (
    <CampaignJobBoardForm
      campaignId={campaignId}
      clientId={clientId}
      disabledIntegrationModules={campaignJobBoards?.data.map(({ clientIntegrationModuleId }) => clientIntegrationModuleId) || []}
      errorMessage={errorMessage}
      isSubmitting={isSubmitting || isLoading || false}
      loadingDisabledIntegrationModules={isLoading || isFetching}
      onSubmitForm={handleSubmit}
      onSuccess={onSuccess}
    />
  );
}

export default AddCampaignJobBoardForm; 